<template>
  <vuestic-navbar class="navbar">
    <header-selector slot="selector" :isOpen.sync="valueProxy"/>
   
    <span slot="center" class="justify--center app-title">
      {{ $t('admin.incomingTrips') }}
    </span>

    <!-- <message-dropdown class="col nav-item"/> -->
    <!-- <notification-dropdown class="col nav-item"/> -->
    <!-- <language-dropdown class="col nav-item"/> -->
    <profile-dropdown class="col nav-item">
      <img src="../../../assets/profile/empty_avatar.jpg"/>
    </profile-dropdown>
  </vuestic-navbar>

</template>

<script>
import VuesticIconVuestic
  from '../../../vuestic-theme/vuestic-components/vuestic-icon/VuesticIconVuestic'
import VuesticNavbar
  from '../../../vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar'
import HeaderSelector from './components/HeaderSelector'
import ProfileDropdown from './components/dropdowns/ProfileDropdown'

export default {
  name: 'app-navbar',

  components: {
    VuesticIconVuestic,
    VuesticNavbar,
    HeaderSelector,
    ProfileDropdown,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    valueProxy: {
      get () {
        return this.isOpen
      },
      set (opened) {
        this.$emit('toggle-menu', opened)
      },
    },
  },
}
</script>

<style lang="scss">
.navbar {
  .app-title{
    font-size: 1.6rem;
  }
}
</style>